import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import App from "./components/App";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(React.createElement(App));

export default App;
